var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable default-case */
import React from 'react';
import { Headline } from '@empiriecom/module-components/Headline';
import styled, { css } from 'styled-components';
import cuid from 'cuid';
import useConfig from '../hooks/useConfig';
// eslint-disable-next-line import/no-cycle
import buildLinkWithArguments from '../../utils/buildLinkWithArguments';
export var HeadlineTestIds;
(function (HeadlineTestIds) {
    HeadlineTestIds["HeadlineId"] = "cmsHeadline__testid";
    HeadlineTestIds["HeadlineIdComponent"] = "headline__component";
})(HeadlineTestIds || (HeadlineTestIds = {}));
export var MarginVariants;
(function (MarginVariants) {
    MarginVariants["Big"] = "1.5rem 0";
    MarginVariants["Medium"] = "0.75rem 0";
    MarginVariants["Small"] = "0.25rem 0";
    MarginVariants["None"] = "0";
})(MarginVariants || (MarginVariants = {}));
var marginStyle = function (type) {
    switch (type) {
        case 'big':
            return MarginVariants.Big;
        case 'medium':
            return MarginVariants.Medium;
        case 'small':
            return MarginVariants.Small;
        default:
            return MarginVariants.None;
    }
};
var styleHeadlineDefault = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  border: none;\n  text-decoration: none;\n  word-break: break-word;\n"], ["\n  padding: 0;\n  border: none;\n  text-decoration: none;\n  word-break: break-word;\n"])));
var StyledHeadlineLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  margin: ", ";\n  display: block;\n  ", "\n"], ["\n  ", "\n  margin: ", ";\n  display: block;\n  ", "\n"])), styleHeadlineDefault, function (_a) {
    var marginVariant = _a.marginVariant;
    return marginStyle(marginVariant);
}, function (_a) {
    var color = _a.color;
    return color && "color: " + color + ";";
});
var StyledHeadlineDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  margin: ", ";\n  ", "\n"], ["\n  ", "\n  margin: ", ";\n  ", "\n"])), styleHeadlineDefault, function (_a) {
    var marginVariant = _a.marginVariant;
    return marginStyle(marginVariant);
}, function (_a) {
    var color = _a.color;
    return color && "color: " + color + ";";
});
var HeadlineExt = Headline;
var StyledHeadline = styled(HeadlineExt)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n  text-decoration: none;\n  color: inherit;\n  ", "\n  ", "\n"], ["\n  margin: 0;\n  text-decoration: none;\n  color: inherit;\n  ", "\n  ",
    "\n"])), function (_a) {
    var font = _a.font;
    return font && "font-family: " + font + ";";
}, function (_a) {
    var level = _a.level, size = _a.size, lineheight = _a.lineheight, letterspacing = _a.letterspacing;
    return (size && size[level] && "font-size: " + size[level] + ";") + "\n      " + (lineheight && lineheight[level] && "line-height: " + lineheight[level] + ";") + "\n      " + (letterspacing && letterspacing[level] && "letter-spacing: " + letterspacing[level] + ";");
});
var CmsHeadline = function (contentData, key) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (key === void 0) { key = ''; }
    var _o = contentData.field_margin_variant, marginVariant = _o === void 0 ? 'none' : _o, linkAddress = contentData.field_link, _p = contentData.field_link_title, linkTitle = _p === void 0 ? '' : _p, _q = contentData.field_link_target, linkTarget = _q === void 0 ? '_self' : _q, headlineText = contentData.field_text, subHeadlineText = contentData.field_text_subheadline, headlineElement = contentData.field_element_type, styleLevel = contentData.field_styling_level, styleVariation = contentData.field_variation, textAlign = contentData.field_text_align, headlineLevel = contentData.field_level, _r = contentData.field_font, headlineFont = _r === void 0 ? 'default' : _r, _s = contentData.field_font_subheadline, subHeadlineFont = _s === void 0 ? 'default' : _s, _t = contentData.field_font_color, fontColor = _t === void 0 ? '' : _t, 
    /* eslint-disable @typescript-eslint/naming-convention */
    field_tracking = contentData.field_tracking, field_link_anchor = contentData.field_link_anchor, field_link_highlight = contentData.field_link_highlight, field_link_searchfilter = contentData.field_link_searchfilter, field_bonus_number = contentData.field_bonus_number;
    var config = useConfig();
    var spacer = styleVariation === 2 ? 'short' : undefined;
    var subHeadlineLevel = Math.min(headlineLevel + 2, 6);
    var subHeadlineStyleLevel = styleLevel
        ? Math.min(styleLevel + 2, 6)
        : undefined;
    var ContentHeadline = (React.createElement(StyledHeadline, { level: headlineLevel, spacer: spacer, stylingLevel: styleLevel, textAlign: textAlign, key: "linkedHeadline-" + cuid(), font: headlineFont, element: headlineElement, size: (_b = (_a = config.fontAdjustments) === null || _a === void 0 ? void 0 : _a.headline) === null || _b === void 0 ? void 0 : _b.size, lineheight: (_d = (_c = config.fontAdjustments) === null || _c === void 0 ? void 0 : _c.headline) === null || _d === void 0 ? void 0 : _d.lineheight, letterspacing: (_f = (_e = config.fontAdjustments) === null || _e === void 0 ? void 0 : _e.headline) === null || _f === void 0 ? void 0 : _f.letterspacing }, headlineText));
    var ContentSubHeadline = subHeadlineText ? (React.createElement(StyledHeadline, { level: subHeadlineLevel, font: subHeadlineFont, textAlign: textAlign, stylingLevel: subHeadlineStyleLevel, element: headlineElement, key: "subheadline-" + cuid(), size: (_h = (_g = config.fontAdjustments) === null || _g === void 0 ? void 0 : _g.headline) === null || _h === void 0 ? void 0 : _h.size, lineheight: (_k = (_j = config.fontAdjustments) === null || _j === void 0 ? void 0 : _j.headline) === null || _k === void 0 ? void 0 : _k.lineheight, letterspacing: (_m = (_l = config.fontAdjustments) === null || _l === void 0 ? void 0 : _l.headline) === null || _m === void 0 ? void 0 : _m.letterspacing }, subHeadlineText)) : null;
    if (linkAddress) {
        return (React.createElement(StyledHeadlineLink, { "data-testid": HeadlineTestIds.HeadlineId, "data-tracking": contentData.field_tracking, href: buildLinkWithArguments(linkAddress, {
                field_tracking: field_tracking,
                field_link_anchor: field_link_anchor,
                field_link_highlight: field_link_highlight,
                field_link_searchfilter: field_link_searchfilter,
                field_bonus_number: field_bonus_number,
            }), target: linkTarget, title: linkTitle, key: key || cuid(), marginVariant: marginVariant, color: fontColor },
            ContentHeadline,
            ContentSubHeadline));
    }
    return (React.createElement(StyledHeadlineDiv, { className: "cms-headline-wrapper", "data-testid": HeadlineTestIds.HeadlineId, "data-tracking": contentData.field_tracking, title: linkTitle, key: key || cuid(), marginVariant: marginVariant, color: fontColor },
        ContentHeadline,
        ContentSubHeadline));
};
export default CmsHeadline;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map